import React, { useState, Component } from 'react';
import { ViralResultCard } from '../components/Analysis/ViralResultCard';
import { WebsiteHeader } from '../components/Dashboard/WebsiteHeader';
export function DebugPage() {
  const [score, setScore] = useState(92);
  return <div className="min-h-screen bg-[#050505] text-white flex flex-col font-sans" data-id="element-3841" data-mp="1rnoi5a1h7n99">
      <WebsiteHeader data-id="element-3842" data-mp="1nop32wm16a43" />

      <main className="flex-1 max-w-6xl mx-auto w-full px-4 py-12 flex flex-col lg:flex-row gap-12 items-start" data-id="element-3843" data-mp="1nmcp0uje8jwb">
        {/* Controls Panel */}
        <div className="w-full lg:w-1/3 bg-[#0A0A0A] border border-gray-800 rounded-2xl p-8 sticky top-24" data-id="element-3844" data-mp="v0b7eniezpvp">
          <h1 className="text-2xl font-black mb-6 tracking-tight" data-id="element-3845" data-mp="18ryc9bqfa6q3">
            Viral Card Debugger
          </h1>

          <div className="mb-8" data-id="element-3846" data-mp="13yn5falm1py6">
            <label className="block text-sm font-mono text-gray-400 mb-4 uppercase tracking-wider" data-id="element-3847" data-mp="13ydbxd1cx0nq">
              Toxicity Score:{' '}
              <span className="text-white font-bold text-lg" data-id="element-3848" data-mp="c9tpzf318gpn">{score}%</span>
            </label>
            <input type="range" min="0" max="100" value={score} onChange={e => setScore(parseInt(e.target.value))} className="w-full h-2 bg-gray-800 rounded-lg appearance-none cursor-pointer accent-red-500" data-id="element-3849" data-mp="19n5kkza63gbb" />
            <div className="flex justify-between text-xs font-mono text-gray-600 mt-2" data-id="element-3850" data-mp="1objntbbhx6se">
              <span data-id="element-3851" data-mp="qo1gm4xhgcqi">0% (Saint)</span>
              <span data-id="element-3852" data-mp="qp2q44yuor64">100% (Final Boss)</span>
            </div>
          </div>

          <div className="space-y-4" data-id="element-3853" data-mp="vnnp612d94sz">
            <h3 className="text-sm font-mono text-gray-400 uppercase tracking-wider mb-2" data-id="element-3854" data-mp="vop44gmi6bfz">
              Quick Test Values
            </h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-3855" data-mp="15lbnf0z6kufw">
              <button onClick={() => setScore(15)} className="bg-gray-900 border border-gray-800 hover:border-green-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-3856" data-mp="15ipfh08docx5">
                15% (Level 1)
              </button>
              <button onClick={() => setScore(45)} className="bg-gray-900 border border-gray-800 hover:border-yellow-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-3857" data-mp="gweitsnnlil8">
                45% (Level 2)
              </button>
              <button onClick={() => setScore(75)} className="bg-gray-900 border border-gray-800 hover:border-orange-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-3858" data-mp="lw9cg3ytcm9z">
                75% (Level 3)
              </button>
              <button onClick={() => setScore(92)} className="bg-gray-900 border border-gray-800 hover:border-red-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-3859" data-mp="3pbokiznmslsh">
                92% (Level 4)
              </button>
            </div>
          </div>

          <div className="mt-8 p-4 bg-gray-900 border border-gray-800 rounded-lg" data-id="element-3860" data-mp="36n00efwz2khr">
            <h3 className="text-sm font-bold mb-2" data-id="element-3861" data-mp="36kxbjz7k2xem">Design Requirements Met:</h3>
            <ul className="text-xs text-gray-400 space-y-2 font-mono" data-id="element-3862" data-mp="2whic7ptv2uzx">
              <li data-id="element-3863" data-mp="31auxbpzc0jnx">✓ Charcoal Black (#0A0A0A) background</li>
              <li data-id="element-3864" data-mp="2mkx42vmjp3rv">✓ Neon Red/Cyber White accents</li>
              <li data-id="element-3865" data-mp="2mm854nolvxfa">✓ Monospaced tech header</li>
              <li data-id="element-3866" data-mp="2rjzy7l0zlpl2">✓ 9:16 Mobile-first aspect ratio</li>
              <li data-id="element-3867" data-mp="2rkrruqb0xd8p">✓ Glowing circular gauge</li>
              <li data-id="element-3868" data-mp="3f9ksh02lc99n">✓ Dynamic Meme-able Labels</li>
              <li data-id="element-3869" data-mp="3favwn0zy7j1a">✓ 3 Indicator dots</li>
              <li data-id="element-3870" data-mp="3f7q4fcw0w11c">✓ Validation Quote Box (Serif)</li>
              <li data-id="element-3871" data-mp="3k7cmbzmsq5gh">✓ Footer with CTA & Watermark</li>
            </ul>
          </div>
        </div>

        {/* Preview Area */}
        <div className="w-full lg:w-2/3 flex justify-center items-center bg-[#111] border border-gray-800 rounded-2xl p-12 min-h-[800px] relative overflow-hidden" data-id="element-3872" data-mp="35dhhd4prh0ak">
          {/* Background grid for preview area */}
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" data-id="element-3873" data-mp="1tykpln26zwzi" />

          {/* The Component */}
          <div className="relative z-10 shadow-[0_0_50px_rgba(0,0,0,0.5)]" data-id="element-3874" data-mp="2aapi7lsvy7b6">
            <ViralResultCard score={score} data-id="element-3875" data-mp="25c4kpu50q1qf" />
          </div>
        </div>
      </main>
    </div>;
}